import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-me',
  templateUrl: './delete-me.component.html',
  styleUrls: ['./delete-me.component.scss']
})
export class DeleteMeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
